<template lang="pug">
div
  .breakText
    el-row
      app-display(
        label="Denominação:",
        :content="imovel.denominacao"
        :class = "compararImovelTransferencia && compararImovelTransferencia.mudouDenominacao ? 'text': '' "
      )
      app-display(
        label="Município:",
        :content="imovel.municipio ? imovel.municipio.nome : ''",
        :class = "compararImovelTransferencia && compararImovelTransferencia.mudouMunicipio ? 'text': '' "
      )
      app-display(
        label="Área:",
        :content="imovel.formattedValueArea !== '0,0000 hectare(s)' ? getArea() : ''",
        :class = "compararImovelTransferencia && compararImovelTransferencia.mudouArea ? 'text': '' "
      )
    info-matricula(:imovel="imovel")
    app-collapse(title="Dados do título")
      el-row
        el-col(:span="24")
          app-display(
            label="Nome do beneficiário:",
            :content="getValue(imovel.nomeBeneficiarioTitulo)"
            :class = "compararImovelTransferencia && compararImovelTransferencia.mudouNomeBeneficiarioTitulo ? 'text': '' "
          )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import InfoMatricula from '@/components/informacoesCadastro/common/InfoMatricula'

export default {
  components: {
    AppDisplay,
    InfoMatricula,
    AppCollapse
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    compararImovelTransferencia: {
      type: Object,
      required: true
    }
  },
  methods: {
    getArea () {
      return this.imovel.formattedValueArea !== undefined ? this.imovel.formattedValueArea : this.imovel.area + ' hectare(s)'
    },
    getValue (params) {
      return params || '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.breakText {
  word-break: break-all;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia.vue